import sprintf from 'sprintf'
import React from 'react'

const Utils = {
  uuid (plus) {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid + plus
  },
  getYMList (plusYear = 0, minYM = 201603, format = '%s年%s月分(%s年%s月納付)') {
    const now = new Date()
    let year = Number(now.getFullYear()) + Number(plusYear)
    let month = now.getMonth() + 1
    const yearMonthList = []
    while (year * 100 + month >= minYM) {
      let nextYear = year
      let nextMonth = month + 1
      if (nextMonth === 13) {
        nextYear++
        nextMonth = 1
      }
      yearMonthList.push({
        id: year * 100 + month,
        name: sprintf(format, year, month, nextYear, nextMonth)
      })
      month--
      if (month === 0) {
        year--
        month = 12
      }
    }
    return yearMonthList
  },
  getIntYM () {
    const nowDate = new Date()
    return nowDate.getFullYear() * 100 + nowDate.getMonth() + 1
  },
  getStringYMDHM () {
    const nowDate = new Date()
    return nowDate.getFullYear() + '/' + ('0' + (nowDate.getMonth() + 1)).slice(-2) + '/' + ('0' + nowDate.getDate()).slice(-2) + ' ' + ('0' + nowDate.getHours()).slice(-2) + ':' + ('0' + nowDate.getMinutes()).slice(-2)
  },
  separate (num) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  },
  convKingaku (kingaku, decimalPlaces = 0, isShowingEmptyStringIfZero = false) {
    if (kingaku === null)kingaku = 0
    const value = Number(kingaku).toFixed(decimalPlaces)
    if (Number(value) === 0 && isShowingEmptyStringIfZero) {
      return ''
    }
    return isFinite(value) ? '¥' + this.separate(value) : ''
  },
  convSuuryou (suuryou, decimalPlaces = 1, isShowingEmptyStringIfZero = false) {
    const value = Number(suuryou).toFixed(decimalPlaces)
    if (value === 0 && isShowingEmptyStringIfZero) {
      return ''
    }
    return isFinite(value) ? this.separate(value) : ''
  },
  getDataFromObjectByKeys (obj, keys, prefix = '') {
    var result = []
    keys.forEach((key) => {
      const upperCasedKey = key.charAt(0).toUpperCase() + key.slice(1)
      const dataKey = prefix + upperCasedKey
      if (dataKey in obj) {
        result[key] = obj[dataKey]
      }
    })
    return result
  },
  nl2br (text) {
    const regex = /(\n)/g
    return text.split(regex).map(function (line) {
      if (line.match(regex)) {
        return React.createElement('br')
      } else {
        return line
      }
    })
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/company_user/libs/Utils.js